import {HStack, Text, VStack} from '@chakra-ui/layout';
import {OrderModalIcon} from '@/components/svg/OrderModalIcon';
import {useTranslation} from 'react-i18next';

export const PanierRecapMarketplaceDate: React.FC = () => {
  const {t} = useTranslation();
  return (
    <VStack
      alignItems='stretch'
      p='5'
      borderRadius='8px'
      bg='blue.bg'
      textColor='blue.main'
    >
      <HStack>
        <OrderModalIcon color='blue.main' />
        <Text>{t('panier.recap.marketplace_livraison_titre')}</Text>
      </HStack>
      <Text
        fontWeight='500'
        fontSize='lg'
      >
        {t('panier.recap.marketplace_livraison_delai')}
      </Text>
    </VStack>
  );
};
